import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SxStyle } from '../../../../types';
import { Box } from '@mui/material';

const styles: SxStyle = {
  closeButton: (theme) => ({
    position: 'absolute',
    right: '8px',
    top: '8px',
    color: theme.palette.grey[500],
  }),
};

export interface SquadDialogProps extends DialogProps {
  title: string;
  onClose?: () => void;
}

export default function SquadDialog({
  title,
  open,
  onClose,
  children,
  ...props
}: SquadDialogProps) {
  return (
    <Dialog open={open} maxWidth={'sm'} fullWidth {...props}>
      <DialogTitle>
        <Box sx={{ mr: 6 }}>{title}</Box>
        {onClose ? (
          <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {children}
    </Dialog>
  );
}
